module.exports = __webpack_public_path__ + "img/home-silder2.f5853cc4.png";